import { render, staticRenderFns } from "./FieldNeedType.vue?vue&type=template&id=06c71570&scoped=true&"
import script from "./FieldNeedType.vue?vue&type=script&lang=js&"
export * from "./FieldNeedType.vue?vue&type=script&lang=js&"
import style0 from "./FieldNeedType.vue?vue&type=style&index=0&id=06c71570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c71570",
  null
  
)

export default component.exports